export const ENV_PRODUCTION = 'production';
export const ENV_DEVELOPMENT = 'development';

export const APP_URL = 'p.cleantalk.org';
export const POLYGON_APP_URL = 'p-dev.cleantalk.org';
export const BETA_APP_URL = 'p-beta.cleantalk.org';
export const LOCAL_APP_URL = 'localhost:3000';
export const POLYGON_API_URL = 'https://polygon-api-ctask.cleantalk.org';
export const PRODUCTION_API_URL = 'https://api-ctask.cleantalk.org';
export const COMMON_API_NEXT_URL = 'https://api-next.cleantalk.org/';
export const COMMON_API_URL = 'https://api.cleantalk.org';
export const ORIGIN_HOST = window.location.origin;

export const isProduction = process.env.NODE_ENV === ENV_PRODUCTION;
export const isDevelopment = process.env.NODE_ENV === ENV_DEVELOPMENT;
export const isTestHost =
    document.location.host === POLYGON_APP_URL
    || document.location.host === BETA_APP_URL
    || document.location.host === LOCAL_APP_URL;
export const isProductionHost = document.location.host === APP_URL;
export const isTestMode = true;

export const STRIPE_LIVE_PUBLIC_KEY = 'pk_live_72fwgeCGK5l1jAxqjEboTHyC';
export const STRIPE_TEST_PUBLIC_KEY = 'pk_test_rKEmSO5sl56IXka8YLw5aBhJ';

export const STRIPE_PUBLIC_KEY = !isProductionHost
    ? STRIPE_TEST_PUBLIC_KEY
    : STRIPE_LIVE_PUBLIC_KEY;

export const tabletWidth = 1172;
export const mobileWidth = 768;

export const isTablet = window.screen.width <= tabletWidth;
export const isMobile = window.screen.width <= mobileWidth;

export const ENV_API_URL = isProduction ? (isTestHost ? POLYGON_API_URL : PRODUCTION_API_URL) : '';
